import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { computed } from 'mobx';
import * as classNames from 'classnames';
import { IAppOnlyStore } from 'stores/AllStores';
import { UploadStatus } from 'common/interfaces/resources';
import { IconButton, FileUpload } from 'components/action';
import { LoadingFullScreen, SavingIndicator, SavingIndicatorStatus } from 'components/indicator';
import { Resource } from './Resource';

// Styles
const s = require('./LeadResources.css');
const addIcon = require('assets/plus icon.svg');
const cancelIcon = require('assets/close orange icon.svg');

// Component
@inject('store')
@observer
export class LeadResources extends React.Component<IAppOnlyStore, {}> {
    public render() {
        const { leadResources } = this.props.store;

        return (
            <div className={s.resources}>

                <div className={s.list}>
                    {(leadResources.all.length > 0) && (
                        <div>
                            {leadResources.all.map((resource) => (
                                <Resource
                                    key={`file-${resource.id}`}
                                    resource={resource}
                                    editing={leadResources.editing}
                                    onDelete={leadResources.removeLeadResource}
                                />
                            ))}
                        </div>
                    ) || (
                        <p className={s.noResources}>No resources have been uploaded for this lead yet.</p>
                    )}
                </div>

                <div className={s.upload}>
                    <FileUpload
                        onChange={leadResources.handleUploadFilesChange}
                        uploading={leadResources.uploadFiles.status === UploadStatus.Saving}
                        files={leadResources.uploadFiles.files}
                        label="Drag files or click to upload resources"
                        multiple={true}
                    />
                </div>

                <LoadingFullScreen active={leadResources.loading} fitInContainer={true} />

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/sales/Lead/Resources/LeadResources.tsx